import apiClient from './client'
import type {
  InboundFilter,
  InboundFilterCreate,
  InboundFilterUpdate,
  InboundFilterListResponse,
  FilterTestRequest,
  FilterTestResult,
} from '../types'

export const filtersApi = {
  listFilters: async (appId: string): Promise<InboundFilterListResponse> => {
    const response = await apiClient.get<InboundFilterListResponse>(`/apps/${appId}/filters`)
    return response.data
  },

  getFilter: async (appId: string, filterId: string): Promise<InboundFilter> => {
    const response = await apiClient.get<InboundFilter>(`/apps/${appId}/filters/${filterId}`)
    return response.data
  },

  createFilter: async (appId: string, data: InboundFilterCreate): Promise<InboundFilter> => {
    const response = await apiClient.post<InboundFilter>(`/apps/${appId}/filters`, data)
    return response.data
  },

  updateFilter: async (
    appId: string,
    filterId: string,
    data: InboundFilterUpdate
  ): Promise<InboundFilter> => {
    const response = await apiClient.put<InboundFilter>(`/apps/${appId}/filters/${filterId}`, data)
    return response.data
  },

  deleteFilter: async (appId: string, filterId: string): Promise<void> => {
    await apiClient.delete(`/apps/${appId}/filters/${filterId}`)
  },

  testFilter: async (
    appId: string,
    filterId: string,
    data: FilterTestRequest
  ): Promise<FilterTestResult> => {
    const response = await apiClient.post<FilterTestResult>(
      `/apps/${appId}/filters/${filterId}/test`,
      data
    )
    return response.data
  },
}

export type { InboundFilter, InboundFilterCreate, InboundFilterUpdate }
